import { createInternalApiAction } from '@app/packages/internalApi/utils'

/**
 * Writes the v3 session cookie pair (`kidsout__at` + the readable
 * `kidsout__at_meta`) atomically server-side. The server derives the expiry and
 * the meta hash from the token, so the client never touches either. `skipAuth`
 * is essential — this runs from inside `onSessionRefreshed`, and authenticating
 * here would re-enter the refresh routine.
 */
export const postSession = (params: { user_id: string; access_token: string }) =>
  createInternalApiAction('postSession', dispatch =>
    dispatch<void>({
      endpoint: '/internal/api/v1/session',
      method: 'POST',
      body: JSON.stringify(params),
      skipAuth: true,
    })
  )

/** Clears the v3 session cookie pair. */
export const deleteSession = () =>
  createInternalApiAction('deleteSession', dispatch =>
    dispatch<void>({
      endpoint: '/internal/api/v1/session',
      method: 'DELETE',
      skipAuth: true,
    })
  )
